import React, { useState, useEffect, Fragment, useRef } from 'react';
import {
  useFlowController,
  useFlowData,
  FlowTypes,
} from '@adaptis/flow-components';
import { Typeahead, AsyncTypeahead } from 'react-bootstrap-typeahead';
import {
  IPetSuburbPCLookupProps,
  IPetSuburbPCLookupAddress,
} from './PetSuburbPCLookup.types';
import { fetchSuburbPostcodeLookup } from '../../util/knose-api-wrapper';
import './PetSuburbPCLookup.scss';
import { AsyncTypeaheadWrapper } from '../WrapperComponent';

export default function PetSuburbPCLookup(props: IPetSuburbPCLookupProps) {
  const { activeStep } = useFlowController();
  const { getData, setData } = useFlowData();
  const filterBySuburb = () => true;
  const [
    optionsISuburbPCLookupAddress,
    setOptionsISuburbPCLookupAddress,
  ] = useState(Array<IPetSuburbPCLookupAddress>());
  const [selected, setSelected] = useState<IPetSuburbPCLookupAddress>();
  const [isLoadingSuburb, setIsLoadingSuburb] = useState(false);
  const typeaheadRef = useRef<any>();

  const [isFocused, setIsFocused] = useState(false);
  const [isTouched, setIsTouched] = React.useState<boolean>(false);
  const [isInvalid, setIsInvalid] = React.useState<boolean>(false);

  function onFocus() {
    setIsFocused(true);
  }
  function onBlur() {
    setIsFocused(false);
    setIsTouched(true);
    validate();
  }
  function labelOnClick() {
    typeaheadRef.current && typeaheadRef.current.focus();
  }

  function validate() {
    if (selected == undefined || selected == null) {
      setIsInvalid(true);
    } else {
      setIsInvalid(false);
    }
  }

  useEffect(() => {
    validate();
  }, [selected]);

  React.useEffect(() => {
    if (activeStep?.showValidations ?? false) {
      setIsTouched(true);
      validate();
    }
  }, [activeStep]);

  async function handleSearch(query: string) {
    setIsLoadingSuburb(true);
    setOptionsISuburbPCLookupAddress([]);

    let result = await fetchSuburbPostcodeLookup(query);

    let newArray: Array<IPetSuburbPCLookupAddress> = new Array<IPetSuburbPCLookupAddress>();
    if (result && result.data) {
      result.data.forEach(
        (address1: { postcode: string; location: string; state: string }) => {
          let sub: IPetSuburbPCLookupAddress = {
            suburb: address1.location,
            state: address1.state,
            postcode: address1.postcode.toString(),
          };
          newArray.push(sub);
        }
      );
    }

    setOptionsISuburbPCLookupAddress(newArray);
    setIsLoadingSuburb(false);
  }

  function handleSelected(selectedOptionList: IPetSuburbPCLookupAddress[]) {
    setIsTouched(true);
    if (selectedOptionList !== null && selectedOptionList.length > 0) {
      if (props.dataField !== undefined) {
        setData(props.dataField, selectedOptionList[0]);
      }
      setSelected(selectedOptionList[0]);
      setOptionsISuburbPCLookupAddress(selectedOptionList);
    } else {
      setSelected(undefined);
      if (props.dataField !== undefined) {
        setData(props.dataField, undefined);
      }
    }
  }

  useEffect(() => {}, []);

  function getDefaultText() {
    if (selected == undefined) {
      let selectedAddressLocal = getData(props.dataField ?? '');
      if (selectedAddressLocal != undefined && selectedAddressLocal != null) {
        const obj = selectedAddressLocal;
        let sub: IPetSuburbPCLookupAddress = {
          suburb: obj.suburb,
          state: obj.state,
          postcode: obj.postcode,
        };

        if (
          optionsISuburbPCLookupAddress &&
          optionsISuburbPCLookupAddress.length === 0
        ) {
          setOptionsISuburbPCLookupAddress([
            { suburb: sub.suburb, state: sub.state, postcode: sub.postcode },
          ]);
        }
        setSelected({
          suburb: sub.suburb,
          state: sub.state,
          postcode: sub.postcode,
        });
        setIsTouched(true);
        return sub.suburb + ', ' + sub.state + ', ' + sub.postcode;
      }
    } else {
      return selected.suburb + ', ' + selected.state + ', ' + selected.postcode;
    }

    return '';
  }

  function isInputEmpty() {
    if (typeaheadRef.current) {
      return typeaheadRef.current.getInput().value === '';
    }
    return true;
  }

  // https://github.com/ericgio/react-bootstrap-typeahead/blob/master/docs/API.md
  return (
    <div
      data-testid='PetSuburbPCLookup'
      className='flc_pet-suburb-p-c-lookup my-3'
    >
      <label
        className={
          (isFocused || selected != undefined || !isInputEmpty()
            ? 'selected '
            : '') + (isInvalid && isTouched ? 'invalid' : '')
        }
        onClick={labelOnClick}
      >
        {props.label}
      </label>

      <AsyncTypeaheadWrapper
        ref={typeaheadRef}
        filterBy={filterBySuburb}
        id='async-example-ISuburbPCLookupAddress'
        isLoading={isLoadingSuburb}
        //labelKey="name"
        useCache={false}
        minLength={3}
        onSearch={handleSearch}
        options={optionsISuburbPCLookupAddress}
        defaultInputValue={getDefaultText()}
        onChange={(selected: any) => {
          handleSelected(selected);
        }}
        labelKey={(option: any) =>
          `${option.suburb}, ${option.state}, ${option.postcode}`
        }
        onFocus={onFocus}
        onBlur={onBlur}
        // placeholder="Search for a Suburb.."
        renderMenuItemChildren={(option: any) =>
          option.suburb + ', ' + option.state + ', ' + option.postcode
        }
        isInvalid={isInvalid && isTouched}
        isValid={isTouched && !isInvalid}
      />
      {props.helpMessage && (
        <div
          className={
            'help-message' + (isInvalid && isTouched ? ' invalid' : '')
          }
        >
          {props.helpMessage}
        </div>
      )}
    </div>
  );
}
